<template src="./index.html">
</template>
<script>
	import {getTempBlanceDataPage,queryCompanySz} from '../../../api/home.js'
	import data from "./data.js"
	export default {
		props: {
			ywdiag: {
				type: Boolean,
				default: false
			},
			isNo:{
				type:Boolean,
				default:false,
			},
			ywtitle:{
				type: String,
				default: "录入业务科目"
			},
			diskm:{
				type: Boolean,
				default: false
			},
			mapping: {
				type: Object,
				default: {
					cellCode: "",
					companyCode: "",
					createBy: "",
					createTime: "",
					declareType: "",
					delFlag: "",
					enableFlag: "",
					formula: "",
					id: "",
					notes: "",
					reportId: "",
					reportName: "",
					ruleId: "",
					ruleNum: "",
					sourceFlag: "",
					companySubjectCode:"",
					companySubjectName: "",
					updateBy: "",
					updateTime: "",
                    tag:[],
					subjectCode:"",
					shuibId:'',
          isCurrentPeriod:'0',
          currentPeriodMonth:''
				}
			},
			relations:{
				type:Array,
				default:[]
			},
            tagOptions:[],
			sourceFlagData:[]
		},
		data: function() {
			return {
				companydiag: false,
				tableData: [],
				chooseitem:"",
				sort: "",
				order: "",
				queryWord:"",
				pagination: data.pagination,
				headtableData: data.headtableData,
				rules: {
					// declareType: [{
					// 	required: true,
					// 	message: '请选择申报税种',
					// 	trigger: 'change'
					// }, ],
					// shuibId: [{
					// 	required: true,
					// 	message: '请选择报表名称',
					// 	trigger: 'change'
					// }],
					// yewkmName: [{
					// 	required: true,
					// 	message: '请输入业务科目名称',
					// 	trigger: 'blur'
					// }],
					yewkmCode: [{
						required: true,
						message: '请输入业务科目编码',
						trigger: 'blur'
					}],
					sourceFlag: [{
						required: true,
						message: '请选择映射方式',
						trigger: 'change'
					}],
					enableFlag: [{
						required: true,
						message: '请选择是否启用',
						trigger: 'change'
					}],
					companySubjectCode : [{
						required: true,
						message: '请选择公司科目',
						trigger: 'blur'
					}],
				},
				radioNow:0,
				selectrow:{},
				Szlist:[],
				Boxlist:[],
				fisrtSubject:{},
				nextSubject:[],
				gzdiag:false,

			};
		},
		watch: {
			ywdiag: function(indexVal, oldVal) {
				if (indexVal) {
					 this.queryCompanySz()
					this.$nextTick(() => {
						this.$refs.mappingRef.clearValidate()
					})
				}
			},
		},
		created() {
			this.sourceFlagData = this.sourceFlagData == null||this.sourceFlagData.length == 0?this.$sourceFlagMapping:this.sourceFlagData;
			this.fisrtSubject = this.relations.length > 0?this.relations[0] : {};
			this.nextSubject = this.relations.length > 1 ? this.relations.splice(1):[];
        },
		methods: {
			//获取税种和报表名称
			queryCompanySz(){
				queryCompanySz().then(res=>{
					if(res.data.code=1){
						this.Szlist=res.data.data
						if(this.ywtitle=="编辑业务科目"||this.isNo){
							this.Szlist.forEach(item=>{
								if(this.mapping.declareType==item.shuizId){
									this.Boxlist=item.children
								}
							})
						}
					}
				})
			},
			//选择税种
			querychange(e){
				this.Szlist.forEach(item=>{
					if(e==item.shuizId){
						this.Boxlist=item.children
					}
				})
			},
			foraddform(){
				this.$refs['mappingRef'].validate((valid) => {
				   if (valid) {
						let params={
							mapping:this.mapping,
							relations:this.relations
						}
						this.$emit("getywkmForm",params)
				   }
				});
			},
			//选择报表change事件:
			reportChange(choose){
				this.Boxlist.forEach(item =>{
					if(choose == item.reportId){
						this.mapping.reportName = item.reportName
						this.mapping.reportId = item.reportId
					}
				});
			},
			getTempBlanceDataPage(){
				let idlist=this.relations.map(item=>item.companySubjectId)
				if(this.$notemptyandnull(this.mapping.companySubjectId)){
					idlist.push(this.mapping.companySubjectId)
				}
				let params ={
					batchNum : this.mapping.batchNum!=undefined?this.mapping.batchNum:"",
					queryWord:this.queryWord,
					filterIds:idlist.filter(gtem=>{
						return gtem!=undefined
					}).join(",")
				}
				params.current = this.pagination.pageNum
				params.size = this.pagination.pageSize
				params.sort = this.sort
				params.order = this.order
				getTempBlanceDataPage(params).then(res=>{
					this.radioNow=null
					this.selectrow={}
					this.pagination.total = res.data.data.total
					this.tableData = res.data.data.records
					this.companydiag=true
				})
			},
			//公司选择
			radiochange(row){
				this.selectrow=row
			},
			cellclick(row){
			this.radioNow=row.id
			this.selectrow=row
			},
			sortchange(data) {
				this.sort = data.prop
				this.order = data.order == "ascending" ? 'asc' : 'desc'
				this.getTempBlanceDataPage()
			},
			sizechange(e) {
				this.pagination.pageSize = e
				this.getTempBlanceDataPage()
			},
			currentChange(e) {
				this.pagination.pageNum = e
				this.getTempBlanceDataPage()
			},
			submitSearch() {
				this.pagination.pageNum = 1
				this.pagination.paginationkey++
				this.getTempBlanceDataPage()
			},
			forOpenDiag(type){
				this.getTempBlanceDataPage()
				this.chooseitem=type
			},
			//确认选择
			forsureGskm(){
				if(this.chooseitem=="main"){
					this.mapping.companySubjectName=this.selectrow.companySubjectName
					this.mapping.companySubjectCode=this.selectrow.companySubjectCode
					this.mapping.companySubjectId=this.selectrow.id
				}else{
					this.relations[this.chooseitem].companySubjectName=this.selectrow.companySubjectName
					this.relations[this.chooseitem].companySubjectCode=this.selectrow.companySubjectCode
					this.relations[this.chooseitem].companySubjectId=this.selectrow.id
				}
				this.companydiag=false
			},
			foradd(index) {
				this.relations.splice(index + 1, 0, {})
			},
			fordelete(index) {
				this.relations = this.relations.filter((item, yindex) => index != yindex)
			},
			closediag() {
				this.$emit("closediag", false)
			}
		}
	};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
